import type { DecisionEngineDestinationDefinition } from "./definition";
import { hightouchPayloadMapping } from "./sync-config-helpers";

export const attentiveDefinition: DecisionEngineDestinationDefinition = {
  destinationType: "attentive",
  category: "event",
  generateSyncConfig: ({ producer, settings, messageTags }) => ({
    object: "custom_event",
    externalIdMapping: {
      from: "external_id",
      to: settings.recipientType === "phone" ? "phone" : "email",
    },
    eventType: "hightouch_interaction",
    mappings: [
      hightouchPayloadMapping({ producer, messageTags }),
      { type: "standard", from: "campaign_id", to: "message_identifier" },
    ],
    externalEventId: { from: "id" },
  }),
  syncStrategy: {
    supportsChannelLevelSync: (channelConfig) =>
      channelConfig.useChannelLevelSync !== false,
  },
};
